/* eslint-disable react/button-has-type */
import React from 'react';
import PropTypes from 'prop-types';

import './button.scss';

const Button = ({children, type, disabled}) => (
  <button className="btn" type={type} disabled={disabled}>
    {children}
  </button>
);

Button.propTypes = {
  children: PropTypes.node.isRequired,
  type: PropTypes.oneOf(['submit', 'button']),
  disabled: PropTypes.bool,
};

Button.defaultProps = {
  type: 'submit',
  disabled: false,
};

export default Button;
